import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { offer } from '../data/content';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { CtaButton } from './CtaButton';
const SHOW_AFTER_PX = 700;
export function StickyBuyBar() {
  const reduceMotion = useReducedMotion();
  const {
    isBannerVisible
  } = useCookieConsent();
  const [isPastHero, setIsPastHero] = useState(false);
  useEffect(() => {
    const onScroll = () => setIsPastHero(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const isVisible = isPastHero && !isBannerVisible;
  return <AnimatePresence data-id="element-205" data-mp="2102le2ub7pql">
      {isVisible ? <motion.aside key="sticky-buy-bar" aria-label="Comprar el Megapack" initial={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} animate={reduceMotion ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-mint-200 bg-white/95 backdrop-blur" data-id="element-206" data-mp="2113ui1rrm25o">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-207" data-mp="2n6nxzelujcwh">
            <div className="min-w-0" data-id="element-208" data-mp="2s5quganrgasu">
              <p className="hidden text-[15px] font-semibold text-ink sm:block" data-id="element-209" data-mp="2s4pim3yx7ka2">
                {offer.label}
              </p>
              <p className="text-sm font-semibold text-ink sm:hidden" data-id="element-210" data-mp="2x64y7gibwyl2">Megapack completo</p>
              <p className="text-sm text-ink-soft sm:hidden" data-id="element-211" data-mp="321kcuao5uyij">
                <span className="font-semibold text-mint-700" data-id="element-212" data-mp="363p5p76sbr44">{offer.price}</span> · Pago único
              </p>
            </div>
            <CtaButton size="md" className="shrink-0" data-id="element-213" data-mp="17rgqvtoli6tw">
              <span className="sm:hidden" data-id="element-214" data-mp="1bs0laphsawcc">{offer.ctaSecondary}</span>
              <span className="hidden sm:inline" data-id="element-215" data-mp="2f1mv4vhmk2k5">{offer.ctaPrimary}</span>
            </CtaButton>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}